import { render, staticRenderFns } from "./RegisterClients.vue?vue&type=template&id=451ca5ea&scoped=true"
import script from "./RegisterClients.vue?vue&type=script&lang=js"
export * from "./RegisterClients.vue?vue&type=script&lang=js"
import style0 from "./RegisterClients.vue?vue&type=style&index=0&id=451ca5ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451ca5ea",
  null
  
)

export default component.exports